import { GridColDef } from '@mui/x-data-grid-pro'
import { tsLimsSample } from '../../../Typescript/StuartPy/Lims'
import { tsLimsIssue } from '../../../Typescript/API_Response'
import { getCodeSetLabelFromList } from '../../../Functions/CodeSetFns'
import { useMemo } from 'react'
import { useBioBankContext } from '../../../Contexts/Modules/BioBankModule'
import { useGetCodeSet } from '../../../APIs/Hooks/CodeSetHooks'

export type SampleSaleItemCol = GridColDef & {
  field: keyof tsLimsSample | 'Price'
}
export const sampleSaleCols: SampleSaleItemCol[] = [
  {
    field: 'id',
    headerName: 'Sample ID',
    flex: 1,
  },
  {
    field: 'Short_Line_Name',
    headerName: 'Short Line Name',
    flex: 2,
  },
  {
    field: 'Sample_Type',
    headerName: 'Sample Type',
    flex: 1,
  },
  {
    field: 'Sample_Details',
    headerName: 'Sample Details',
    flex: 2,
  },
  {
    field: 'Sex',
    headerName: 'Sex',
    flex: 1,
  },
  {
    field: 'Age_of_animal_at_collection_(days)',
    headerName: 'Age (Days)',
    flex: 1,
  },
  {
    field: 'Storage_Media',
    headerName: 'Storage Media',
    flex: 2,
  },
  {
    field: 'Freezing_method',
    headerName: 'Freezing Method',
    flex: 2,
  },
  {
    field: 'Method_of_Euthanasia',
    headerName: 'Method of Euthanasia',
    flex: 2,
  },
  {
    field: 'Price',
    headerName: 'Price',
    flex: 1,
    valueFormatter: (value) => (value ? `$${value}` : ''),
  },
]

export type SampleIssueItemCol = GridColDef & {
  field: keyof tsLimsIssue | 'cancel'
}

export function useGetSampleIssueCols() {
  const { statusQuery } = useBioBankContext()
  const organCodesQuery = useGetCodeSet('OrganTypeID')
  return useMemo(() => {
    const sampleIssueCols: SampleIssueItemCol[] = [
      {
        field: 'LIMSSampleId',
        headerName: 'LIMS Sample Id',
        flex: 1,
      },
      {
        field: 'SampleType',
        headerName: 'Sample Type',
        flex: 1,
        valueFormatter: (value) =>
          getCodeSetLabelFromList(organCodesQuery?.data ?? [], value),
      },
      {
        field: 'SampleIssueStatus',
        headerName: 'Issue Status',
        flex: 1,
        valueFormatter: (value) =>
          getCodeSetLabelFromList(statusQuery.data, value),
      },
      {
        field: 'ShortLineName',
        headerName: 'Short Line Name',
        flex: 1,
      },
      {
        field: 'UAI',
        headerName: 'UAI',
        flex: 1,
      },
      {
        field: 'AnimalID',
        headerName: 'Animal ID',
        flex: 1,
      },
    ]
    return sampleIssueCols
  }, [statusQuery, organCodesQuery.data])
}
